module.exports = __webpack_public_path__ + "static/DS_others-3d3a2d93794dd35be26cadea301056cc.jpg";